import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

/**
 * Almacenamiento del processId del onboarding en sessionStorage.
 *
 * Decisión: se guarda en texto plano. Justificación:
 *  - El `processId` es un UUID identificador de la solicitud, NO material de autenticación
 *    (la auth la lleva el header `x-api-key` añadido por apiKeyInterceptor).
 *  - sessionStorage ya está aislado por pestaña y se borra al cerrarla.
 *  - "Encriptar" en el cliente con una llave del propio bundle es ofuscación, no seguridad
 *    real (la llave es recuperable desde DevTools). Real encryption requiere coordinación
 *    server-side, fuera del alcance de un identificador de sesión.
 *
 * Si en el futuro se almacena material genuinamente sensible (tokens JWT, datos PII), debe
 * migrarse a un esquema con server-side wrapping o cookies HttpOnly — no a Web Crypto con
 * llave embebida.
 */
const STORAGE_KEY = 'idOnboarding';

@Injectable({ providedIn: 'root' })
export class OnboardingIdStorage {
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  set(processId: string): void {
    if (!this.isBrowser) return;
    sessionStorage.setItem(STORAGE_KEY, processId);
  }

  /** Retorna el processId guardado o null si no existe / no estamos en browser. */
  get(): string | null {
    if (!this.isBrowser) return null;
    return sessionStorage.getItem(STORAGE_KEY);
  }

  clear(): void {
    if (!this.isBrowser) return;
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
